import { Button, DialogActions, Stack } from '@mui/material';

interface ActionBarProps {
  onNowClick: () => void;
  onClear: () => void;
  onOk: () => void;
}

export const ActionBar = ({ onNowClick, onClear, onOk }: ActionBarProps) => (
  <DialogActions
    sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
    }}
  >
    <Button onClick={onNowClick}>Now</Button>
    <Stack flexDirection="row">
      <Button onClick={onClear}>Clear</Button>
      <Button onClick={onOk}>OK</Button>
    </Stack>
  </DialogActions>
);
